import { CONTACT_EMAIL } from "config/contact";

const contact = {
  company: "ALGermanist",
  owner: "Mafdi Garas",
  address: "Schottenstraße, 78462 Konstanz, Deutschland",
  email: CONTACT_EMAIL,
  website: "https://algermanist.com",
  host: "IONOS SE, Elgendorfer Str. 57, 56410 Montabaur, Deutschland",
};

const content = {
  de: {
    langLabel: "Deutsch",
    title: "Datenschutz & Cookie-Einstellungen",
    subtitle: "Datenschutzerklärung",
    updated: "Stand: Juni 2026",
    intro:
      "Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften, insbesondere der Datenschutz-Grundverordnung (DSGVO).",
    sections: [
      {
        title: "1. Allgemeine Hinweise",
        body: [
          "Diese Datenschutzerklärung informiert Sie darüber, welche personenbezogenen Daten wir erheben, wie wir diese verwenden und welche Rechte Sie haben.",
        ],
      },
      {
        title: "2. Verantwortlicher",
        body: [
          `${contact.company}`,
          `Inhaber: ${contact.owner}`,
          contact.address,
          `E-Mail: ${contact.email}`,
          `Webseite: ${contact.website}`,
        ],
      },
      {
        title: "3. Hosting",
        body: [
          `Unsere Webseite wird bei folgendem Anbieter gehostet: ${contact.host}.`,
          "Der Hosting-Anbieter verarbeitet personenbezogene Daten zum Zweck der Bereitstellung, Stabilitat und Sicherheit der Webseite.",
        ],
      },
      {
        title: "4. Zugriffsdaten und Server-Logfiles",
        body: [
          "Beim Besuch dieser Webseite werden automatisch Informationen durch den Server erfasst. Dazu gehoren insbesondere IP-Adresse, Datum und Uhrzeit der Anfrage, Browsertyp und Browserversion, verwendetes Betriebssystem, Referrer-URL und Hostname des zugreifenden Rechners.",
          "Diese Daten dienen der technischen Bereitstellung und Sicherheit der Webseite.",
        ],
      },
      {
        title: "5. Kontaktaufnahme",
        body: [
          "Wenn Sie uns per Kontaktformular oder E-Mail kontaktieren, werden Ihre Angaben zur Bearbeitung Ihrer Anfrage gespeichert. Dabei können insbesondere Name, E-Mail-Adresse, Telefonnummer, Nachrichteninhalt und weitere freiwillige Angaben verarbeitet werden.",
          "Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO sowie Art. 6 Abs. 1 lit. f DSGVO.",
        ],
      },
      {
        title: "6. Buchung von Kursen",
        body: [
          "Über unsere Webseite können kostenpflichtige Kurse, Workshops und Veranstaltungen gebucht werden. Dabei verarbeiten wir insbesondere Vor- und Nachname, E-Mail-Adresse, Telefonnummer, Zahlungsinformationen, gebuchte Kurse und Rechnungsdaten.",
          "Die Verarbeitung erfolgt zur Vertragsdurchfuhrung und Organisation der Kurse. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.",
        ],
      },
      {
        title: "7. Zahlungsmethoden",
        body: [
          "Für die Zahlungsabwicklung nutzen wir externe Zahlungsdienstleister, insbesondere Stripe Payments Europe Ltd. in Irland, PayPal (Europe) S.a r.l. et Cie, S.C.A. in Luxemburg sowie Banküberweisung.",
          "Bei Überweisungen verarbeiten wir die von Ihnen übermittelten Zahlungsdaten zur Zahlungsabwicklung. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.",
        ],
      },
      {
        title: "8. Bewerbungen und Vermittlung",
        body: [
          "Interessenten können Bewerbungsunterlagen übermitteln, insbesondere Lebenslauf, Motivationsschreiben, Sprachzertifikate, Zeugnisse, weitere Bewerbungsunterlagen und Passfoto, falls erforderlich.",
          "Die Daten werden zum Zweck der Bewerbungsberatung, der Vermittlung an potenzielle Arbeitgeber, der Kommunikation mit Interessenten und der Unterstutzung beim Einstieg in den deutschen Arbeitsmarkt verarbeitet.",
          "Bewerbungsunterlagen können an potenzielle Arbeitgeber und Ausbildungsbetriebe in Deutschland weitergeleitet werden. ALGermanist übernimmt keine Garantie für eine erfolgreiche Vermittlung, Arbeitsstelle, einen Ausbildungsplatz, ein Visum oder eine Einstellung.",
          "Nach Weiterleitung der Unterlagen übernimmt ALGermanist keine Verantwortung für die weitere Datenverarbeitung durch die jeweiligen Arbeitgeber oder Unternehmen. Die Speicherung der Bewerberdaten erfolgt maximal für drei Jahre oder bis zum Widerruf der Einwilligung.",
          "Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO sowie Art. 6 Abs. 1 lit. b DSGVO.",
        ],
      },
      {
        title: "9. Verwendung von Zoom",
        body: [
          "Unsere Kurse und Meetings finden online über Zoom Video Communications, Inc. statt. Dabei können insbesondere Name, E-Mail-Adresse, Audio- und Videodaten, Chatnachrichten und technische Verbindungsdaten verarbeitet werden.",
          "Aufzeichnungen, Screenshots oder Weitergabe von Unterrichtsinhalten sind ohne ausdrückliche Zustimmung nicht gestattet. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.",
        ],
      },
      {
        title: "10. WhatsApp-Gruppen",
        body: [
          "Zur organisatorischen Kommunikation können WhatsApp-Gruppen verwendet werden. Dabei können andere Teilnehmer insbesondere Telefonnummer, Profilname und Profilbild sehen.",
          "Mit Teilnahme an der WhatsApp-Gruppe erklären sich Teilnehmer mit dieser Sichtbarkeit einverstanden. Die Kommunikation mit dem Dozenten erfolgt ausschließlich über den Gruppenchat. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO.",
        ],
      },
      {
        title: "11. Cookies und Tracking-Technologien",
        body: [
          "Diese Webseite verwendet Cookies und ähnliche Technologien für technische Funktionalität, Sicherheit, Nutzerfreundlichkeit, statistische Auswertungen und Analyse des Nutzerverhaltens.",
          "Nicht technisch notwendige Cookies werden erst nach ausdrücklicher Einwilligung gesetzt.",
        ],
      },
      {
        title: "12. Arten von Cookies",
        body: [
          "Technisch notwendige Cookies sind erforderlich, damit die Webseite korrekt funktioniert, beispielsweise für Sicherheitsfunktionen, Formularfunktionen, Buchungssysteme und Spracheinstellungen.",
          "Analyse- und Statistik-Cookies helfen uns dabei zu verstehen, wie Besucher unsere Webseite nutzen, um Inhalte und Funktionen zu verbessern. Dabei kann insbesondere Google Analytics verwendet werden. Die Aktivierung erfolgt ausschließlich nach Ihrer Einwilligung.",
          "Unsere Webseite kann externe Dienste und Inhalte verwenden, beispielsweise Zoom, Stripe, PayPal und YouTube. Dabei können personenbezogene Daten an die jeweiligen Anbieter übertragen werden.",
        ],
      },
      {
        title: "13. Google Analytics",
        body: [
          "Diese Webseite kann Google Analytics, einen Webanalysedienst von Google Ireland Limited, verwenden. Google Analytics wird ausschließlich nach ausdrücklicher Zustimmung des Nutzers aktiviert.",
          "Dabei können insbesondere gekürzte IP-Adresse, Browserinformationen, Nutzungsverhalten und technische Geräteinformationen verarbeitet werden. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO.",
          "Sie können Ihre Einwilligung jederzeit über die Cookie-Einstellungen widerrufen.",
        ],
      },
      {
        title: "14. Cookie-Einstellungen verwalten",
        body: [
          "Sie können Ihre Cookie-Einstellungen jederzeit ändern oder widerrufen. Nicht technisch notwendige Cookies und Tracking-Technologien werden nur nach Ihrer Zustimmung aktiviert.",
        ],
      },
      {
        title: "15. Weitergabe von Daten",
        body: [
          "Eine Weitergabe personenbezogener Daten erfolgt nur, wenn dies zur Vertragserfüllung erforderlich ist, bei gesetzlicher Verpflichtung, mit ausdrücklicher Einwilligung oder an technische Dienstleister im Rahmen der Webseitenbereitstellung.",
        ],
      },
      {
        title: "16. Datenverarbeitung ausserhalb der EU",
        body: [
          "Im Rahmen technischer oder organisatorischer Tatigkeiten kann ein Zugriff auf personenbezogene Daten durch Dienstleister ausserhalb der Europaischen Union erfolgen. Dabei achten wir auf angemessene Sicherheitsmassnahmen und einen datenschutzkonformen Umgang.",
        ],
      },
      {
        title: "17. Speicherdauer",
        body: [
          "Personenbezogene Daten werden nur so lange gespeichert, wie dies für die jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.",
        ],
      },
      {
        title: "18. SSL- bzw. TLS-Verschlüsselung",
        body: ["Diese Webseite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung."],
      },
      {
        title: "19. Rechte der betroffenen Personen",
        body: [
          "Sie haben insbesondere das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit, Widerspruch, Widerruf einer Einwilligung und Beschwerde bei einer Datenschutzaufsichtsbehörde.",
        ],
      },
      {
        title: "20. Widerspruch gegen Werbe-E-Mails",
        body: [
          "Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung wird widersprochen.",
        ],
      },
      {
        title: "21. Änderungen dieser Datenschutzerklärung",
        body: [
          "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte rechtliche Anforderungen oder technische Änderungen anzupassen.",
        ],
      },
    ],
  },
  en: {
    langLabel: "English",
    title: "Privacy Policy & Cookie Settings",
    subtitle: "Privacy Policy",
    updated: "Last updated: June 2026",
    intro:
      "Protecting your personal data is important to us. We process personal data confidentially and in accordance with applicable data protection laws, especially the GDPR.",
    sections: [
      {
        title: "1. General Information",
        body: [
          "This privacy policy explains which personal data we collect, how we use it, and which rights you have.",
        ],
      },
      {
        title: "2. Controller",
        body: [
          `${contact.company}`,
          `Owner: ${contact.owner}`,
          contact.address,
          `Email: ${contact.email}`,
          `Website: ${contact.website}`,
        ],
      },
      {
        title: "3. Hosting",
        body: [
          `This website is hosted by ${contact.host}.`,
          "The hosting provider processes personal data to provide, stabilize, and secure the website.",
        ],
      },
      {
        title: "4. Access Data and Server Log Files",
        body: [
          "When this website is visited, the server automatically collects technical information such as IP address, date and time of the request, browser type and version, operating system, referrer URL, and hostname of the accessing computer.",
          "This data is used for technical delivery and security of the website.",
        ],
      },
      {
        title: "5. Contact",
        body: [
          "If you contact us by contact form or email, we store the information required to process your request, including name, email address, phone number, message content, and other voluntary information.",
          "Legal basis: Art. 6(1)(b) GDPR and Art. 6(1)(f) GDPR.",
        ],
      },
      {
        title: "6. Course Bookings",
        body: [
          "Paid courses, workshops, and events can be booked through the website. We process data such as first and last name, email address, phone number, payment information, booked courses, and billing data.",
          "Processing is carried out for contract performance and course organization. Legal basis: Art. 6(1)(b) GDPR.",
        ],
      },
      {
        title: "7. Payment Methods",
        body: [
          "We use external payment providers for payment processing, including Stripe Payments Europe Ltd. in Ireland, PayPal (Europe) S.a r.l. et Cie, S.C.A. in Luxembourg, and bank transfer.",
          "For bank transfers, we process the payment data you provide for payment settlement. Legal basis: Art. 6(1)(b) GDPR.",
        ],
      },
      {
        title: "8. Applications and Placement",
        body: [
          "Applicants may submit documents such as CV, motivation letter, language certificates, school or university certificates, other application documents, and a passport photo where required.",
          "The data is processed for application advice, placement with potential employers, communication with applicants, and support entering the German labor market.",
          "Application documents may be forwarded to potential employers and training companies in Germany. ALGermanist does not guarantee successful placement, a job, a vocational training place, a visa, or hiring.",
          "After forwarding documents, ALGermanist is not responsible for further data processing by the respective employer or company. Applicant data is stored for a maximum of three years or until consent is withdrawn.",
          "Legal basis: Art. 6(1)(a) GDPR and Art. 6(1)(b) GDPR.",
        ],
      },
      {
        title: "9. Use of Zoom",
        body: [
          "Courses and meetings take place online through Zoom Video Communications, Inc. Data such as name, email address, audio and video data, chat messages, and technical connection data may be processed.",
          "Recordings, screenshots, or distribution of lesson content are not permitted without explicit consent. Legal basis: Art. 6(1)(b) GDPR.",
        ],
      },
      {
        title: "10. WhatsApp Groups",
        body: [
          "WhatsApp groups may be used for organizational communication. Other participants may see phone number, profile name, and profile picture.",
          "By joining a WhatsApp group, participants agree to this visibility. Communication with the teacher takes place only through the group chat. Legal basis: Art. 6(1)(a) GDPR.",
        ],
      },
      {
        title: "11. Cookies and Tracking Technologies",
        body: [
          "This website uses cookies and similar technologies for technical functionality, security, usability, statistics, and analysis of user behavior.",
          "Non-essential cookies are set only after explicit consent.",
        ],
      },
      {
        title: "12. Types of Cookies",
        body: [
          "Technically necessary cookies are required for the website to work correctly, for example security functions, forms, booking systems, and language settings.",
          "Analytics and statistics cookies help us understand how visitors use the website so we can improve content and functions. Google Analytics may be used for this purpose and is activated only after consent.",
          "The website may use external services and content such as Zoom, Stripe, PayPal, and YouTube. Personal data may be transferred to the respective providers.",
        ],
      },
      {
        title: "13. Google Analytics",
        body: [
          "This website may use Google Analytics, a web analytics service by Google Ireland Limited. Google Analytics is activated only after explicit user consent.",
          "Processed data may include shortened IP address, browser information, usage behavior, and technical device information. Legal basis: Art. 6(1)(a) GDPR.",
          "You can withdraw your consent at any time through the cookie settings.",
        ],
      },
      {
        title: "14. Managing Cookie Settings",
        body: [
          "You can change or withdraw your cookie preferences at any time. Non-essential cookies and tracking technologies are activated only after your consent.",
        ],
      },
      {
        title: "15. Sharing Data",
        body: [
          "Personal data is shared only where required for contract performance, where legally required, with explicit consent, or with technical service providers for operating the website.",
        ],
      },
      {
        title: "16. Processing Outside the EU",
        body: [
          "As part of technical or organizational activities, service providers outside the European Union may access personal data. We use appropriate safeguards and data protection-compliant handling.",
        ],
      },
      {
        title: "17. Retention Period",
        body: [
          "Personal data is stored only as long as necessary for the respective purposes or as required by statutory retention obligations.",
        ],
      },
      {
        title: "18. SSL/TLS Encryption",
        body: ["This website uses SSL/TLS encryption for security reasons."],
      },
      {
        title: "19. Rights of Data Subjects",
        body: [
          "You have rights of access, rectification, deletion, restriction of processing, data portability, objection, withdrawal of consent, and complaint to a data protection supervisory authority.",
        ],
      },
      {
        title: "20. Objection to Advertising Emails",
        body: [
          "Use of contact data published under legal notice obligations for unsolicited advertising is objected to.",
        ],
      },
      {
        title: "21. Changes to This Privacy Policy",
        body: [
          "We reserve the right to update this privacy policy to reflect changed legal requirements or technical changes.",
        ],
      },
    ],
  },
  ar: {
    langLabel: "العربية",
    title: "سياسة الخصوصية وإعدادات ملفات تعريف الارتباط",
    subtitle: "سياسة الخصوصية",
    updated: "آخر تحديث: يونيو 2026",
    intro:
      "نحن نهتم بحماية بياناتك الشخصية ونتعامل معها بسرية ووفقًا لقوانين حماية البيانات وخاصة اللائحة العامة لحماية البيانات الأوروبية (DSGVO).",
    sections: [
      {
        title: "1. معلومات عامة",
        body: [
          "توضح هذه الصفحة كيفية جمع واستخدام البيانات الشخصية وحقوق المستخدم.",
        ],
      },
      {
        title: "2. الجهة المسؤولة عن معالجة البيانات",
        body: [
          `${contact.company}`,
          `المالك: ${contact.owner}`,
          contact.address,
          `البريد الإلكتروني: ${contact.email}`,
          `الموقع الإلكتروني: ${contact.website}`,
        ],
      },
      {
        title: "3. الاستضافة",
        body: [
          `يتم استضافة الموقع لدى: ${contact.host}.`,
          "ويتم استخدام خدمات الاستضافة لضمان تشغيل الموقع وأمانه واستقراره.",
        ],
      },
      {
        title: "4. بيانات الدخول وملفات السجل",
        body: [
          "عند زيارة الموقع يتم تلقائيًا تسجيل بعض البيانات التقنية مثل عنوان IP، وقت وتاريخ الطلب، نوع المتصفح، نظام التشغيل، والصفحة المحول منها المستخدم.",
          "ويتم استخدام هذه البيانات لأغراض الأمان وتحسين استقرار الموقع.",
        ],
      },
      {
        title: "5. التواصل",
        body: [
          "عند التواصل معنا عبر نموذج التواصل أو البريد الإلكتروني نقوم بحفظ البيانات اللازمة لمعالجة الطلب، وقد تتم معالجة الاسم، البريد الإلكتروني، رقم الهاتف، محتوى الرسالة ومعلومات إضافية اختيارية.",
          "الأساس القانوني: Art. 6 Abs. 1 lit. b DSGVO و Art. 6 Abs. 1 lit. f DSGVO.",
        ],
      },
      {
        title: "6. حجز الدورات",
        body: [
          "يمكن حجز الدورات وورش العمل عبر الموقع. وقد تتم معالجة الاسم، البريد الإلكتروني، رقم الهاتف، بيانات الدفع، بيانات الفاتورة وبيانات الدورة المحجوزة.",
          "الأساس القانوني: Art. 6 Abs. 1 lit. b DSGVO.",
        ],
      },
      {
        title: "7. وسائل الدفع",
        body: [
          "يتم استخدام مزودي خدمات دفع خارجيين مثل Stripe وPayPal والتحويل البنكي. وقد يتم نقل بيانات الدفع إلى مزودي الخدمة لإتمام عملية الدفع.",
          "الأساس القانوني: Art. 6 Abs. 1 lit. b DSGVO.",
        ],
      },
      {
        title: "8. طلبات التوظيف والوساطة",
        body: [
          "يمكن للمستخدمين إرسال السيرة الذاتية، خطاب الدافع، شهادات اللغة، الشهادات الدراسية، مستندات إضافية وصورة شخصية عند الحاجة.",
          "ويتم استخدام البيانات من أجل الاستشارة المهنية، التواصل مع جهات التوظيف، ودعم المتقدمين لدخول سوق العمل الألماني.",
          "وقد يتم إرسال البيانات إلى أصحاب عمل أو جهات تدريب داخل ألمانيا. ولا يقدم ALGermanist أي ضمان للحصول على وظيفة أو تدريب أو تأشيرة.",
          "وبعد إرسال البيانات لا يتحمل ALGermanist أي مسؤولية عن طريقة معالجة البيانات لدى جهة العمل. يتم حفظ بيانات المتقدمين لمدة أقصاها ثلاث سنوات أو حتى سحب الموافقة.",
          "الأساس القانوني: Art. 6 Abs. 1 lit. a DSGVO و Art. 6 Abs. 1 lit. b DSGVO.",
        ],
      },
      {
        title: "9. استخدام Zoom",
        body: [
          "تتم الدورات والاجتماعات عبر Zoom. وقد تتم معالجة الاسم، البريد الإلكتروني، الصوت والصورة، الرسائل داخل المحادثة وبيانات الاتصال التقنية.",
          "ولا يسمح بتسجيل الدروس أو إعادة نشر المحتوى دون إذن صريح. الأساس القانوني: Art. 6 Abs. 1 lit. b DSGVO.",
        ],
      },
      {
        title: "10. مجموعات WhatsApp",
        body: [
          "قد يتم استخدام مجموعات WhatsApp للتواصل التنظيمي. وبالانضمام للمجموعة يوافق المشارك على إمكانية ظهور رقم الهاتف، الاسم والصورة الشخصية.",
          "ويتم التواصل مع المدرس فقط عبر الجروب. الأساس القانوني: Art. 6 Abs. 1 lit. a DSGVO.",
        ],
      },
      {
        title: "11. ملفات تعريف الارتباط والتتبع",
        body: [
          "يستخدم الموقع ملفات تعريف الارتباط وتقنيات مشابهة لضمان الأداء التقني، الأمان، سهولة الاستخدام، التحليل والإحصائيات وتحسين الخدمات.",
          "ولا يتم تفعيل ملفات تعريف الارتباط غير الضرورية إلا بعد موافقة المستخدم.",
        ],
      },
      {
        title: "12. أنواع ملفات تعريف الارتباط",
        body: [
          "الملفات الضرورية تقنيًا ضرورية لعمل الموقع بشكل صحيح مثل الأمان، النماذج، أنظمة الحجز وإعدادات اللغة.",
          "ملفات التحليل والإحصائيات تساعدنا على فهم استخدام الزوار للموقع وتحسين المحتوى والخدمات. وقد يتم استخدام Google Analytics لهذا الغرض بعد الموافقة فقط.",
          "قد يستخدم الموقع خدمات خارجية مثل Zoom وStripe وPayPal وYouTube.",
        ],
      },
      {
        title: "13. Google Analytics",
        body: [
          "قد يستخدم هذا الموقع خدمة Google Analytics من Google Ireland Limited لتحليل استخدام الموقع، ولا يتم تشغيل الخدمة إلا بعد موافقة المستخدم بشكل صريح.",
          "وقد تتم معالجة عنوان IP المختصر، معلومات المتصفح، سلوك الاستخدام ومعلومات الجهاز. الأساس القانوني: Art. 6 Abs. 1 lit. a DSGVO.",
          "يمكن سحب الموافقة في أي وقت من خلال إعدادات ملفات تعريف الارتباط.",
        ],
      },
      {
        title: "14. إدارة إعدادات Cookies",
        body: [
          "يمكن للمستخدم تعديل أو سحب موافقته في أي وقت من خلال إعدادات ملفات تعريف الارتباط.",
        ],
      },
      {
        title: "15. مشاركة البيانات",
        body: [
          "لا يتم نقل البيانات الشخصية إلا عند الضرورة لتنفيذ الخدمات، عند وجود التزام قانوني، بموافقة صريحة، أو إلى مزودي الخدمات التقنية المرتبطين بتشغيل الموقع.",
        ],
      },
      {
        title: "16. معالجة البيانات خارج الاتحاد الأوروبي",
        body: [
          "قد يتم الوصول إلى البيانات الشخصية من قبل مزودي خدمات خارج الاتحاد الأوروبي ضمن الإجراءات التقنية أو التنظيمية مع اتخاذ إجراءات حماية مناسبة.",
        ],
      },
      {
        title: "17. مدة تخزين البيانات",
        body: [
          "يتم الاحتفاظ بالبيانات فقط للمدة اللازمة لتحقيق الغرض المطلوب أو وفق الالتزامات القانونية.",
        ],
      },
      {
        title: "18. تشفير SSL/TLS",
        body: ["يستخدم الموقع تشفير SSL/TLS لحماية نقل البيانات."],
      },
      {
        title: "19. حقوق المستخدم",
        body: [
          "يحق للمستخدم معرفة البيانات المخزنة، تصحيح البيانات، حذف البيانات، تقييد المعالجة، الاعتراض على المعالجة، سحب الموافقة وتقديم شكوى لدى جهة حماية البيانات المختصة.",
        ],
      },
      {
        title: "20. الاعتراض على الرسائل الإعلانية",
        body: [
          "يُمنع استخدام بيانات التواصل المنشورة لإرسال إعلانات غير مرغوب بها.",
        ],
      },
      {
        title: "21. تعديل سياسة الخصوصية",
        body: [
          "نحتفظ بحق تعديل سياسة الخصوصية عند الحاجة القانونية أو التقنية.",
        ],
      },
    ],
  },
};

export default content;
